<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="导师来自">
        <div class="row">
          <template v-for="enterprise in enterprises">
            <div class="flex xs2">
              <va-card
                overlay
                titleOnImage
                :image="enterprise.logo"
                :title="enterprise.name"
              >
              </va-card>
              <va-input
                v-model="enterprise.sortNum"
                type="number"
                :min="1"
              >
                <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(enterprise)">
                </va-button>
              </va-input>
            </div>
          </template>
        </div>
      </va-card>
    </div>
    <div class="flex xs6">
      <va-card title='新增学校/企业'>
        <div class='flex xs12 sm6 xs8'>
          <va-input
            v-model='insertData.name'
            label='学校/企业名称'
            removable
            :messages="messages"
          />
        </div>
        <div class='flex xs12  sm6 xs8' v-show="insertData.logo.length!==0">
          <va-card
            overlay
            :image='insertData.logo'
            class="va-card-image"
          >
          </va-card>
        </div>
        <div class='flex xs12  sm6 xs8'>
          <va-card title='学校/企业Logo'>
            <va-file-upload
              type='single'
              v-model='insertData.logoArr'
              @input="uploadEnterpriseImage"
            />
          </va-card>
        </div>
        <div class="flex xs12 sm6 xs8">
          <va-input v-model="insertData.sortNum"
            label="排序"
            placeholder="数字越小越靠前"
            removable
            type="number"
            :min="1"
          />
        </div>
        <div class='flex xs12 sm6 xs8'>
          <va-button class="ma-0" color="primary" slot="trigger" @click="submit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
    <div class="flex xs6">
      <va-card title='删除学校/企业'>
        <div class='flex xs12 sm6 xs8'>
          <va-input
            v-model='deleteEnterpriseName'
            label='学校/企业名称'
            removable
            :messages="messages"
          />
        </div>
        <div class='flex xs12 sm6 xs8'>
          <va-button class="ma-0" color="primary" slot="trigger" @click="submitDeleteEnterprise">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import enterpriseApi from '../../api/enterprise'
import uploadApi from '../../api/upload'

export default {
  name: 'teacherFrom',
  data () {
    return {
      enterprises: [],
      pageSize: 1000,
      totalPages: 1,
      insertData: {
        name: '',
        logo: '',
        logoArr: [],
        sortNum: null,
      },
      messages: ['Required field'],
      deleteEnterpriseName: '',
      submitButtonStatus: true,
    }
  },
  computed: {
    flipEnterprises () {
      const Enterprises = {}
      this.enterprises.forEach(x => {
        Enterprises[x.name.toUpperCase()] = x.id
      })
      return Enterprises
    },
  },
  created () {
    this.listEnterprise()
  },
  methods: {
    listEnterprise (pageNumber = 1) {
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
      }
      enterpriseApi.listEnterprise(params).then(response => {
        this.enterprises = response.enterprises
        this.totalPages = response.totalPage
        console.log(this.enterprises.length)
        console.log(this.enterprises)
      }).catch(error => {
        console.log(error)
      })
    },
    uploadEnterpriseImage () {
      if (this.insertData.logoArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.insertData.logoArr[0])
      // 保存avatar图片
      uploadApi.uploadImage(formData).then(response => {
        console.log(response)
        this.insertData.logo = response.url
      })
    },
    submit () {
      if (this.insertData.name.length === 0 || this.insertData.logo.length === 0) {
        this.showToast('有必填字段未填写，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      this.changeButtonStatus(false)
      enterpriseApi.saveEnterprise({ name: this.insertData.name, logo: this.insertData.logo, sortNum: this.insertData.sortNum }).then(response => {
        this.reset()
        this.listEnterprise()
      }).catch(error => {
        this.changeButtonStatus(true)
        console.log(error)
      })
    },
    submitDeleteEnterprise () {
      if (this.deleteEnterpriseName.length === 0) {
        this.showToast('有必填字段未填写，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      const enterpriseId = this.flipEnterprises[this.deleteEnterpriseName.toUpperCase()]
      if (enterpriseId === undefined) {
        this.showToast('学校/企业名未找到，请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      enterpriseApi.deleteEnterprise(enterpriseId).then(response => {
        this.listEnterprise()
      }).catch(error => {
        console.log(error)
      })
    },
    reset () {
      this.insertData = {
        name: '',
        logo: '',
        logoArr: [],
        sortNum: null,
      }
    },
    updateSortNum: function (params) {
      enterpriseApi.updateEnterprise(params.id, { name: params.name, logo: params.logo, sortNum: params.sortNum }).then(response => {
        this.reset()
        if (response.success === true) {
          this.listEnterprise()
        }
      }).catch(error => alert(error))
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}
</script>

<style scoped>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>